import Heading, {
  HeadingLevels,
  HeadingDefaultLevel,
} from './Heading';

export default Heading;

export {
  HeadingLevels,
  HeadingDefaultLevel,
};
